import { Component, inject, Input } from '@angular/core';
import { CampaignWithPreviewReportingDTO, CommercialWithPreviewReportingDTO } from '../../models/campaigns.model';
import { DateTransformationService } from '../../services/transformation-helper/date-transformation.service';

@Component({
  selector: 'sb-comp-progressbar-wrapper',
  templateUrl: './sb-progressbar-wrapper.component.html',
  styleUrls: ['./sb-progressbar-wrapper.component.scss'],
  standalone: false,
})
export class SbProgressbarWrapperComponent {
  protected readonly dateTransformation = inject(DateTransformationService);
  @Input({ required: true }) campaignOrCommercial: CampaignWithPreviewReportingDTO | CommercialWithPreviewReportingDTO;
}
